<template>
	<v-container fluid grid-list-md class="py-2 px-2">
		<v-layout wrap row class="mt-5">
			<v-flex xs12 md5></v-flex>
			<v-flex xs12 md3>
				<v-text-field
					v-model="filter.filename"
					:label="$t('Name')"
				></v-text-field>
			</v-flex>
			<v-flex xs12 md3>
				<v-text-field
					v-model="filter.created_at"
					type="date"
					clearable
				></v-text-field>
			</v-flex>
			<v-flex xs12 md1 class="text-center">
				<v-btn @click="$emit('onFilter')" color="cyan" block>
					<half-circle-spinner
						v-if="!loading"
						:animation-duration="1000"
						:size="20"
						color="#ffff"
					/>{{ $t("Filter") }}</v-btn
				>
			</v-flex>
		</v-layout>
	</v-container>
</template>

<script>
import { HalfCircleSpinner } from "epic-spinners";
export default {
	props: ["value", "loading"],
	components: {
		HalfCircleSpinner,
	},
	computed: {
		filter: {
			get() {
				return this.value;
			},
			set(value) {
				this.$emit("input", value);
			},
		},
	},
	watch: {
		filter: {
			handler() {
				this.$emit("filter");
			},
			deep: true,
		},
	},
};
</script>